<div class="container">
    <section>
        <div class="row">
            <div class="col-md-8 col-md-offset-2 ">
                <h1>Consultar tramite</h1>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla quam velit, vulputate eu pharetra
                    nec, mattis ac neque. Duis vulputate commodo.</p>
                <hr>
                <form autocomplete="off" [formGroup]="formBusquedaTramite" (ngSubmit)="onSubmit()">
                    <legend>
                        <h2 class="m-b-2">Búsqueda</h2>
                    </legend>
                    <br>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group item-form"
                                [ngClass]="{ 'has-error': validaciones && formulario.tipo_doc.errors }">
                                <label for="tipo_doc">Tipo de Documento</label>
                                <select id="tipo_doc" name="tipo_doc" class="form-control" formControlName="tipo_doc">
                                    <option value="DNI">DNI</option>
                                    <option value="CI">Cédula de Identidad</option>
                                    <option value="LE">Libreta de Enrolamiento</option>
                                    <option value="LC">Libreta Cívica</option>
                                    <option value="CC">Cédula de Ciudadanía</option>
                                    <option value="PAS">Pasaporte</option>
                                </select>
                                <p *ngIf="validaciones && formulario.tipo_doc.errors"
                                    class="help-block error text-danger">
                                    Elegí un tipo de documento</p>
                            </div>
                        </div>

                        <div class="col-md-8">
                            <div class="col-md-6">
                                <div class="form-group item-form"
                                    [ngClass]="{ 'has-error': validaciones && formulario.nro_doc.errors }">
                                    <label for="nro_doc" id="mostrar-tipo">Número de documento</label>
                                    <input type="text" min="1" class="form-control" id="nro_doc" name="nro_doc"
                                        aria-required="true" formControlName="nro_doc">
                                    <p class="help-block error text-danger"
                                        *ngIf="validaciones && formulario.nro_doc.errors?.required">Ingresá un número
                                        de
                                        documento</p>
                                    <p class="help-block error text-danger"
                                        *ngIf="validaciones && formulario.nro_doc.errors?.pattern">Ingresá un
                                        documento válido
                                    </p>
                                </div>
                            </div>
                            <div class="col-4 col-md-6">
                                <label><br></label>

                                <button class="btn btn-primary btn-block">
                                    Buscar </button>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="row m-y-1" *ngIf="formEnviado">
                    <div class="col-md-12">
                        <h4>Resultado de Búsqueda:</h4>
                    </div>
                </div>

                <div *ngIf="formEnviado">
                    <section [ngClass]="result.id_estado == 4 ? 'panel-border-verde-aloe' : 'panel-border-mandarina'"
                        class="panel panel-default" *ngFor="let result of resultado">
                          <div class="panel-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <p><strong>Documento</strong></p>
                                    <p>{{result.tipo_documento}} {{result.numero_documento}}</p>
                                </div>
                                <div class="col-md-6">
                                    <p><strong>Estado</strong></p>
                                    <p *ngIf="result.id_estado == 1">Proceso Iniciado</p>
                                    <p *ngIf="result.id_estado == 2">En Proceso de Validación</p>
                                    <p *ngIf="result.id_estado == 3">En Proceso de Firma Digital</p>
                                    <p *ngIf="result.id_estado == 4" class="text-verde-aloe">Proceso Finalizado y
                                        Firmado
                                    </p>
                                    <p *ngIf="result.id_estado == 5" class="text-danger">Proceso Finalizado con Errores
                                        en Firma
                                    </p>
                                    <p *ngIf="result.id_estado == 6" class="text-danger">Certificado Anulado
                                    </p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <p><strong>Nombres</strong></p>
                                    <p>{{result.nombre}}</p>
                                </div>
                                <div class="col-md-6">
                                    <p><strong>Apellidos</strong></p>
                                    <p>{{result.apellido}}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <p><strong>Matrícula</strong></p>
                                    <p>{{result.matricula}}</p>
                                </div>
                                <div class="col-md-6">
                                    <p><strong>Expediente</strong></p>
                                    <p>{{result.expediente}}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <p><strong>Profesion</strong></p>
                                    <p>{{result.profesion}}</p>
                                </div>
                                <div class="col-md-6">
                                    <p><strong>Fecha Expedición:</strong></p>
                                    <p>{{result.fecha_expedicion}}</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <p><strong>Fecha Matriculación:</strong></p>
                                    <p>{{result.fecha_matriculacion}}</p>
                                </div>
                            </div>
                            <div class="row m-y-2" *ngIf="result.id_estado == 4">
                                <div class="col-md-4">
                                    <a (click)="descargarArchivo(result.id_proceso,result.apellido,result.numero_documento)"
                                        class="btn btn-link p-y-1"><i class="fa fa-download"></i> Descargar</a>
                                </div>
                                <div class="col-md-6" *ngIf="showAdmin">
                                    <a (click)="anular(result.id_proceso)" class="btn btn-danger p-y-1 text-white"
                                        style="background-color: #d60606;" data-toggle="modal"
                                        data-target="#modalAnular"><i class="fa fa-times"></i>
                                        Anular</a>
                                </div>
                            </div>
                            <!-- <div class="row m-y-2" *ngIf="result.id_estado == 2">
                                <div class="col-md-12">
                                    <a (click)="continuarTramite(result.id_proceso)"
                                        class="btn btn-link p-y-1"> Continuar</a>
                                </div>
                            </div> -->
                            <div class="row m-y-2" *ngIf="result.id_estado == 5">
                                <div class="col-md-12">
                                    <a (click)="reintentarFirma(result.id_proceso)"
                                        class="btn btn-primary p-y-1">Reintentar Firma</a>
                                </div>
                            </div>
                            <div *ngIf="error" aria-live="polite" class="alert alert-warning">
                                <li>{{errorArchivoDes}}</li>
                            </div>
                        </div>
                    </section>
                </div>

                <div *ngIf="sinResultados && !validaciones" aria-live="polite" class="alert alert-warning">
                    <li>{{resultadosVacio}}</li>
                </div>
                <br>
                <br>
                <div class="row">
                    <div class="col-sm-12">
                        <button routerLink="/home" class="btn btn-link">Volver</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<!-- Modal -->
<div class="modal" id="modalAnular" tabindex="1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document" style="max-width: 1080px;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Motivos de Anulación</h5>
                <button id="closeModal" type="button" class="close" data-dismiss="modal">X</button>
            </div>
            <div class="modal-body" style="height: 100px;">
                <div class="col-md-12">
                    <form [formGroup]="anularForm" autocomplete="off" (ngSubmit)="onSubmitAnular()">
                        <fieldset>
                            <div class="row">
                                <div class="col-md-12 form-group item-form" [ngClass]="{ 'has-error': validaciones && formularioAnular.observacion.errors }">
                                    <label for="observacion">Motivo</label>
                                    <textarea name="observacion" formControlName="observacion" class="form-control"
                                        id="observacion" required="" aria-required="true"></textarea>
                                    <p *ngIf="validaciones && formularioAnular.observacion.errors"
                                        class="help-block error text-danger">
                                        Ingresa un Motivo</p>

                                </div>
                            </div>
                        </fieldset>
                        <button type="submit" class="btn btn-success">Guardar</button>

                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    </form>
                </div>
            </div>
            <div class="modal-footer" style="border-top:none">
               
            </div>
        </div>
    </div>
</div>